import { db, firebaseAuth } from './firebaseConfig';
import I18n from 'core/I18n/I18n';
import keyEnum from 'core/I18n/KeyEnum';
import { userReference, groupReference } from './user';
import { executeAndFormat, deleteItem, updateItem, addItem, getItem, execute } from './firebaseFunctions';

export const getPlan = ({ scope, hasPower, teamUsers, id }) => {
    const promises = [];
    teamUsers.map(user => {
        let table = db.collection("Plan").where("active", "==", true)/* .where("isPlan", "==", true); */
    
        if(!hasPower){
            table = table.where("user", "==", userReference(user));
        }
    
        if (scope && scope.value) {
            table = table.where("group", "==", groupReference(scope));
        } else if (id) {
            table = db.collection("Plan").doc(id);
        } else {
            throw new Error(I18n[keyEnum.groupFieldRequired]);
        }
    
        promises.push(executeAndFormat(table, [{ key: 'group'}, {key: 'user'}, {key: 'template'}], [], (planItem => {
            planItem.date = { ...planItem.date };
        })));
    })

    return Promise.all(promises).then(all => {
        return all.flat();
    })
}

export const deletePlan = async (id) => {
    return deleteItem("Plan", id);
}

export const addOrUpdate = async (item) => {
    let { id, group, user } = item;

    const data = { ...item };
    if (id) {
        data['id'] = id;
    }
    if (group) {
        data['group'] = groupReference(group);
    }

    if (user) {
        data['user'] = userReference(user);
    }

    if (id) {
        return updateItem("Plan", data);
    } else {
        return addItem("Plan", data).then(item => {
            return ({...item, user})
        });
    }
}

export const addPlanMessage = (id, data) => {
    // data -> description, date, idUser, nmUser
    return addItem(`Plan/${id}/messages`, data).then(item => {
        return ({...item})
    });
}

export const getPlanMessages = (id) => {
    return getItem(`Plan/${id}/messages`);
}

export const addCompentence = (id, data) => {
    return addItem(`Plan/${id}/competences`, data).then(item => {
        return ({...item})
    });
}

export const addAction = (id, competenceId, data) => {
    return addItem(`Plan/${id}/competences/${competenceId}`, data).then(item => {
        return ({...item})
    });
}